import React, {FC} from 'react';

import {Box, DialogActions, DialogContent, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import Button from 'components/button/Button';
import {useAppSelector} from 'hooks';
import {StyledDialog} from 'views/address-drawer/styles';
import {BasketWeightCapacityComponent} from 'views/basket-express-weight-limit/BasketWeightCapacity.component';

import ExpressPicture from '../../assets/images/express-picture-yellow-bg.png';

export interface ExpressWeightCapacityModalProps {
  open: boolean;
  onClose: () => void;
}

export const ExpressWeightCapacityModal: FC<ExpressWeightCapacityModalProps> = ({open, onClose}) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state.basket);

  const weightThreshold = basket?.expressWeightKgLimit;
  const dimensionThreshold = basket?.expressDimensionLimit;

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <Box component="img" width={160} height={160} src={ExpressPicture}></Box>
        </Box>
        <Typography textAlign="center" fontSize={20} fontWeight={700}>
          {t('express.title.weightCapacityModal')}
        </Typography>
        <BasketWeightCapacityComponent fullWidth />
        <Typography textAlign="center" fontSize={16} whiteSpace="pre-line">
          <Trans i18nKey="express.message.weightCapacityModal" values={{weightThreshold, dimensionThreshold}} />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button shape="rounded" variant="contained" fullWidth onClick={onClose}>
          {t('label.close')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

ExpressWeightCapacityModal.displayName = 'ExpressWeightCapacityModal';
